import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { WidgetAssetPreviewComponent } from '../../../../asset/widget-asset-preview/widget-asset-preview.component';
import * as dot from 'ts-dot-prop';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../../../@core/services/notification/notification.service';
import { Asset, AssetInput } from '../../../../../generated/generated-types';
import { AssetService } from '../../../../asset/services/asset.service';

@Component({
  selector: 'app-widget-featured-asset',
  templateUrl: './widget-featured-asset.component.html',
  standalone: true,
  imports: [
    WidgetAssetPreviewComponent
  ]
})
export class WidgetFeaturedAssetComponent extends FieldType<FieldTypeConfig> {

  cdRef = inject(ChangeDetectorRef);
  constructor(
    private assetService: AssetService,
    private notificationService: NotificationService,
    private i18n: I18nService
  ) {
    super();
  }

  ngAfterViewInit() {
    // this.field.formControl.valueChanges.subscribe((value) => {
    //   console.log("valueChanges 6");
    //   console.log(value);
    // });
  }

  async onFilesSelected(files: File[]) {

    if (files?.length == 1) {

      let input: AssetInput = {
        file: files[0],
        name: "test"
      }

      let res = await this.assetService.saveAsset(input);

      // let updateAddress: AddressInput = {
      //   id: address?.id,
      //   featuredAssetId: res.id
      // };
      // this.model.featuredAssetId = res.id;
      // console.log("updateAddress");
      // console.log(updateAddress);

      // await this.companyService.saveItem(updateAddress);
      this.formControl.setValue(res);
      if (!this.props?.withoutNotification)
        this.notificationService.success(_("common.save-successful"));
    }
  }

  getAsset(key: string | number | (string | number)[]) {
    let asset: Asset = {} as Asset;
    if (this.model)
      asset = dot.get(this.model, key as string);
    return asset;
  }

}
